import navBarHomepage from '../modules/navbar-homepage';
import config from '../config';
import { pollManager } from '../modules/collection_poll';

let collectionController = () => {
    require('../modules/custom-content-manager')();
    navBarHomepage.on();
    if (config.get('featureFlags.pollsEnabled') === true) {
        pollManager().init();
    }
};

export default collectionController;
